







































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment'
import AlertArea from "../../components/AlertArea.vue"
import DropArea from "../../components/DropArea.vue"
import PdfRenderArea from "../../components/PdfRenderArea.vue"
import { Sheet } from "../../modules/student/MondaiPdfRender"

export interface Data {
  sheet_id: string
  sheet: Sheet
  base64Pdf: string
  remainingTime: number
  testEndDateTime: number
  timer: any
  isTimeOver: boolean
  isShow: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "pdf-render-area": PdfRenderArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const pdfRenderAreaRef = ref<InstanceType<typeof PdfRenderArea>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet(),
      base64Pdf: "",
      remainingTime: null,
      testEndDateTime: null,
      timer: null,
      isTimeOver: false,
      isShow: false,
      errors: new Array<string>()
    });

    /******************************
     * computed
     ******************************/

    // 残り時間・画面表示用文字列
    const remainingTimeText = computed((): string => {
      // ミリ秒からdurationオブジェクトを生成
      const duration = moment.duration(state.remainingTime);
      
      // 日・時・分・秒を取得
      const days = Math.floor(duration.asDays());
      const hours   = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      // カウントダウンの結果を変数に代入
      if(days > 0){
        return '残り時間：' + days + '日' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(hours > 0){
        return '残り時間：' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(minutes > 0){
        return '残り時間：' +  minutes + '分' + seconds + '秒';
      }else{
        return '残り時間：' +  seconds + '秒';
      }
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/student/mondai_pdf?sheet_id=${state.sheet_id}&student_no_character=${context.root.$store.state.student_no_character}`).then(response => {
        
        const sheet = new Sheet();
        sheet.grade = response.data.sheet.grade;
        sheet.name = response.data.sheet.name;
        sheet.curriculum_id = response.data.sheet.curriculum_id;
        sheet.question_image_completed = response.data.sheet.question_image_completed;
        state.sheet = sheet;
        
        state.remainingTime = response.data.remaining_time;
        state.testEndDateTime = Date.now() + (response.data.remaining_time * 1000);
        state.isShow = true;

        context.root.$nextTick(() => {
          if(state.sheet.question_image_completed){
            state.base64Pdf = response.data.base64_pdf;
          }
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$router.push(`/${context.root.$store.state.currentUser.school_id}/student_site/sheet_list`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");

      // タイマー処理
      state.timer = setInterval(function(){

        // 現在日時取得
        var now = Date.now();

        // テスト終了日時から現在日時を減算し、残り時間を求める
        state.remainingTime = (state.testEndDateTime - now);

        // 残り時間があるか判定
        if(state.remainingTime <= 0){
          // PDF非表示に切り替え
          state.isTimeOver = true;

          // タイマー停止
          clearInterval(state.timer);
        }
      }, 200);
    });

    /******************************
     * methods
     ******************************/
  
    return {
      ...toRefs(state),
      pdfRenderAreaRef,
      remainingTimeText,
    };
  }
});
